import { useCallback, useState } from 'react'
import { useMounted } from '../../Hooks/useMounted'
import { AuthAPI } from '../../Services/API/AuthAPI'
import { ServiceLocator } from '../../Services/ServiceLocator'

export const useResetPassword = () => {
  const mounted = useMounted()

  const [processing, setProcessing] = useState(false)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>(null)

  const resetPassword = useCallback(
    async (email: string, challenge?: string) => {
      setProcessing(true)
      return ServiceLocator.resolve(AuthAPI)
        .resetPassword(email, challenge)
        .then(() => {
          if (mounted.current) {
            setError(false)
            setErrorMessage(null)
            setProcessing(false)
          }
        })
        .catch((err) => {
          if (mounted.current) {
            setError(true)
            setErrorMessage(err.message)
            setProcessing(false)
            throw Error(err)
          }
        })
    },
    [mounted],
  )

  return {
    processing,
    error,
    errorMessage,
    resetPassword,
  }
}
